export function getValidationFieldErrors(details: Record<string, unknown> | undefined, fallback: string): Record<string, string> {
  if (!details) {
    return {};
  }
  return Object.fromEntries(
    Object.entries(details)
      .map(([field, value]) => [field, validationMessage(value, fallback)] as const)
      .filter(([, message]) => Boolean(message))
  );
}

function validationMessage(value: unknown, fallback: string): string {
  if (typeof value === "string") {
    return value || fallback;
  }
  if (Array.isArray(value)) {
    const messages = value.filter((item): item is string => typeof item === "string" && item.length > 0);
    return messages.join(" ") || fallback;
  }
  if (isRecord(value) && typeof value.message === "string") {
    return value.message || fallback;
  }
  return fallback;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
